import { reduce } from 'lodash'

export const transformedItemsToRevenueCenter = (
  allItems,
  selectedItemsUuids
) => {
  // itemsForMenu takes array of selected items and add them to the particular menu uuid and seek for deselected
  // items and remove from them particular menuUuid
  const itemsForMenu = reduce(
    selectedItemsUuids,
    (res, cur, idx) => {
      // idx in this func is an uuid of particular menu
      const removedItems = allItems
        .filter((item) => item.menuUuids.includes(idx))
        .filter((item) => !cur.includes(item.uuid))

      const removedItemsWithoutMenuUuids = removedItems.reduce(
        (res, item) => {
          const newMenuUuids = item.menuUuids.filter(
            (menuUuid) => menuUuid !== idx
          )
          const itemsWithNewMenuUuids = {
            ...item,
            menuUuids: newMenuUuids,
          }
          return [...res, itemsWithNewMenuUuids]
        },
        []
      )

      const selectedItems = allItems
        .filter((item) => cur.includes(item.uuid))
        .filter((item) => !item.menuUuids.includes(idx))

      const selectedItemsWithMenuUuid = selectedItems.reduce(
        (res, item) => {
          const newMenuUuids = [...item.menuUuids, idx]
          const itemsWithNewMenuUuids = {
            ...item,
            menuUuids: newMenuUuids,
          }
          return [...res, itemsWithNewMenuUuids]
        },
        []
      )

      return [
        ...res,
        ...removedItemsWithoutMenuUuids,
        ...selectedItemsWithMenuUuid,
      ]
    },
    []
  )
  return itemsForMenu
}
